module.exports = __webpack_public_path__ + "static/fipcpinkcloud3-de8491837eeb4544e51f225640c17392.jpeg";